<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <div
          class="box"
          v-if="containerDetails.length>0 && (designation=='manager' || designation=='surveyer' || designation=='Admin' )"
        >
          <b-navbar
            class="formCard"
            style=" border-radius: 5px !important;padding-left:0px"
            toggleable="lg"
            type="dark"
            variant="primary"
          >
            <b-navbar-brand center>Survey & Repair Details</b-navbar-brand>

            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button
                  size="sm"
                  variant="warning"
                  v-if="designation!='surveyer'"
                  @click="goToMain"
                >New Gate-In</b-button>
              </b-nav-form>
            </b-navbar-nav>
          </b-navbar>
        
            
                <b-row >
                  <b-col md="12" class="my-1">
                    <b-form-group>
                      <b-input-group>
                        <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search"/>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Main table element -->
                        <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="containerDetails"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template slot="gateInId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="containerNo" slot-scope="row1">
                    <span
                      @click="viewContainerInPage(row1.item.containerGateInId,row1.item.gateInId)"
                      class="showMoreData"
                    >{{(row1.item.containerNo=='' || row1.item.gateInType=='Empty_Vehicle')?" --- ":row1.item.containerNo}}</span>
                  </template>
                  <template slot="loginTime" slot-scope="row12">
                    <span>{{row12.item.loginTime | moment}}</span>
                  </template>
                  <template slot="delaySurveyStatus" slot-scope="row123">
                    <div v-if="row123.item.delaySurveyStatus==1">
                      <span style="color:red">Not Completed In 24 Hours</span>
                      <br>
                    </div>
                    <div v-else-if="row123.item.delaySurveyStatus==0">
                      <span style="color:red">Survey Pending</span>
                    </div>
                    <div v-else>
                      <span style="color:green">Survey Done</span>
                    </div>
                  </template>
                  <template slot="shippingLine" slot-scope="row2">
                    <span>
                      {{row2.item.shippingLine }}
                      <br>
                    </span>
                    <span>
                      {{row2.shippingApproval=='' || row2.shippingApproval==null?"Status : N/A":"Status: " + row2.shippingApproval}}
                      <br>
                    </span>
                  </template>
                  <template slot="shippingApproval" slot-scope="row3">
                    <span
                      :style="row3.item.repairCompletedNot==null || row3.item.repairCompletedNot==''?{ 'color': 'red' }:{ 'color': 'green' }"
                    >{{row3.item.shippingApproval!='Approved'?" ---":row3.item.repairCompletedNot==null || row3.item.repairCompletedNot==''?"Pending":'Repair Done' }}</span>
                  </template>
                  <template slot="containerStatus" slot-scope="row32">
                    <span
                      :style="row32.item.containerStatus==1 || row32.item.repairCompletedNot=='Repair_Done'?{ 'color': 'green' }:{'color': 'red'}"
                    >{{row32.item.containerStatus==1?"Completed":row32.item.repairCompletedNot=="Repair_Done"?"Ready to Gate Out":"Pending"}}</span>
                  </template>

                  <template slot="repairCompletedNot" slot-scope="row13">
                    <div v-if="designation=='manager'">
                      <div
                        v-if="row13.item.repairCompletedNot=='Repair_Done' && designation=='manager' && row13.item.containerStatus==0"
                      >
                        <md-switch
                          :id="'approval'+row13.item.containerGateInId"
                          name="approval"
                          class="md-primary"
                          :value="row13.item.repairStatusCon==1 && row13.item.repairCompletedNot=='Repair_Done' ?true:false"
                          @change="disableGateOut(row13.item,index)"
                        >{{row13.item.repairStatusCon==1 && row13.item.repairCompletedNot=='Repair_Done'?'Yes':'No'}}</md-switch>
                        <br>
                      </div>
                      <div v-else>
                        <span style="color:red">N/A</span>
                      </div>
                    </div>
                    <div v-else>
                      <span>N/A</span>
                    </div>
                  </template>
                </b-table>
                        </div>
                <b-row>
                  <b-col md="12" class="my-1">
                    <b-pagination
limit="5"
                    align="center"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-0 "
                    />
                  </b-col>
                </b-row>
            
       
        </div>

        <div class="box" v-if="designation!='surveyer'">
          <hr class="hr-s">
          <b-navbar
            class="formCard"
            style=" border-radius: 5px !important;padding-left:0px"
            toggleable="lg"
            type="dark"
            variant="primary"
          >
            <b-navbar-brand center>Gate-In Details</b-navbar-brand>

            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button size="sm" variant="warning" @click="goToMain">New Gate-In</b-button>
              </b-nav-form>
            </b-navbar-nav>
          </b-navbar>
         
          
                <b-row class="gutr">
                  <b-col md="12" class="my-1">
                    <b-form-group>
                      <b-input-group>
                        <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search"/>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
        <div class="table-responsive tableMain">
                <!-- Main table element -->
                <b-table
                  show-empty
                  stacked="md"
                  :items="itemServiceDetails"
                  :fields="fields1"
                  :current-page="currentPage1"
                  :per-page="perPage1"
                  :filter="filter1"
                  :sort-by.sync="sortBy1"
                  :sort-desc.sync="sortDesc1"
                  :sort-direction="sortDirection1"
                  @filtered="onFiltered1"
                >
                  <template slot="gateInId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="gateInSeries" slot-scope="row10">
                    <span
                      @click="viewGateInPage(row10.item.gateInId)"
                      class="showMoreData"
                    >{{row10.item.gateInSeries}}</span>
                  </template>
                  <template slot="containerNo" slot-scope="row1">
                    <span
                      @click="viewContainerInPage(row1.item.containerGateInId,row1.item.gateInId)"
                      class="showMoreData"
                    >{{(row1.item.containerNo=='' || row1.item.gateInType=='Empty_Vehicle')?" --- ":row1.item.containerNo}}</span>
                  </template>
                  <template slot="loginTime" slot-scope="row12">
                    <span>{{row12.item.loginTime | moment}}</span>
                  </template>
                  <template slot="delaySurveyStatus" slot-scope="row123">
                    <div v-if="row123.item.delaySurveyStatus==1">
                      <span style="color:red">Not Completed In 24 Hours</span>
                      <br>
                    </div>
                    <div v-else-if="row123.item.delaySurveyStatus==0">
                      <span style="color:red">Survey Pending</span>
                    </div>
                    <div v-else>
                      <span style="color:green">Survey Done</span>
                    </div>
                  </template>
                  <template slot="shippingLine" slot-scope="row2">
                    <span>
                      {{row2.item.shippingLine }}
                      <br>
                    </span>
                  </template>

                  <template slot="maintenanceRequest" slot-scope="row13">
                    <div>
                      <span
                        style="color:red"
                      >{{(row13.item.maintenanceRequest==null)?"--":item.maintenanceRequest}}</span>
                    </div>
                  </template>
                </b-table>
        </div>
                <b-row>
                  <b-col md="12" class="my-1">
                    <b-pagination
                    align="center"
                      :total-rows="totalRows1"
                      :per-page="perPage1"
                      v-model="currentPage1"
                      class="my-0 "
                    />
                  </b-col>
                </b-row>
         
         
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Yard")) {
      this.$store.dispatch("setCurrentRoute", "/yard/GateIn");
      this.viewServiceEstimation();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      fields: [
        {
          key: "gateInId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "containerNo",
          label: "Container No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "loginTime",
          label: "Arrival Date & Time",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "delaySurveyStatus",
          label: "Survey Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "shippingLine",
          label: "Shipping Line Approval",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "shippingApproval",
          label: "Repair Status",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "containerStatus",
          label: "Gate-Out Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "repairCompletedNot",
          label: "Gate-Out Permission",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      fields1: [
        {
          key: "gateInId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "gateInSeries",
          label: "Gate-In No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "gateInType",
          label: "Gate-In Type",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "containerNo",
          label: "Container No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "vehicleNo",
          label: "Vehicle No",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "shippingLine",
          label: "Shipping Line Approval",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "loginTime",
          label: "Arrival Date & Time",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "delaySurveyStatus",
          label: "Survey Status",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "maintenanceRequest",
          label: "Delayed Survey",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage1: 1,
      perPage1: 10,
      totalRows1: "",
      pageOptions1: [5, 10, 15],
      sortBy1: null,
      sortDesc1: false,
      sortDirection1: "desc",
      filter1: null,
      modalInfo1: { title: "", content: "" },
      isLoading: true,
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      alert: {
        content:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      itemServiceDetails: [],
      containerDetails: [],
      designation: "",
      departmentName: "",
      itemObj: "",
      indexNew: ""
    };
  },
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY  hh:mm");
    }
  },

  mounted() {
    // this.$sessionsStorage.set("editServiceId", "");
    // // this.JqueryFun();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    // Loading
    CustomLoader,
  },
  computed: {
    itemMasterList() {
      return this.itemDetail;
    },
    vehicleMasterList() {
      return this.vehicleDetail;
    },
    locationMasterList() {
      return this.locationMaster;
    },
    employeeMasterList() {
      return this.employeeMaster;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields1
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    disableGateOut(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.containerGateInId;

      this.itemObj.repairStatusCon = this.itemObj.repairStatusCon == 1 ? 0 : 1;
      let paylod = {
        tableName: "yard_gateincontainer",
        tableId: "containerGateInId",
        tableIsActive: "repairStatusCon",
        value1: this.itemObj.repairStatusCon,
        tableVal: this.deleteId
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/updateAllIsActiveData.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.containerDetails[this.indexNew] = this.itemObj;
              
          }
        })
        .catch(error => {});
    },
    goToMain() {
      this.$sessionsStorage.set("editContainerId", "");
      this.$sessionsStorage.set("editGateInId", "");
      this.$router.push({
        path: "/yard/GateIn"
      });
    },
    removeCss() {
      // console.log("gdfg");
      $(".md-active").remove();
    },
    viewContainerInPage(id, gateIn) {
      this.$sessionsStorage.set("editContainerId", id);
      this.$sessionsStorage.set("editGateInId", gateIn);
      this.$router.push({
        path: "/yard/editContainerRepair"
      });
    },

    hideVehicle() {
      if (this.serviceDetails.maintenanceType == "Yard") {
        this.serviceDetails.engineNo = "";
        this.serviceDetails.vehicleNo = "";
        this.serviceDetails.driverName = "";
        this.serviceDetails.chassisNo = "";
        this.serviceDetails.yearOfPurchase = "";
      }
    },
    JqueryFun() {
      return $(function() {
        $("#stockIntable3333").DataTable();
        $("#surveyView").DataTable();
      });
    },
    requestItemCallback(item) {
      //console.log(item);
      this.itemModal.itemCode = item.itemCode;
      this.itemModal.itemId = item.itemId;
      // this.console.log(item.itemId, "abc");
    },

    requestVehicleCallback(item1) {
      // console.log(item1);
      this.serviceDetails.engineNo = item1.engineNo;
      this.serviceDetails.chassisNo = item1.chassisNo;
      this.serviceDetails.driverName = item1.driverName;
      this.serviceDetails.vehicleId = item1.vehicleTruckId;
    },
    viewGateInPage(GATEID) {
      // console.log(serviceEstimationID);
      this.$sessionsStorage.set("editGateInId", GATEID);
      this.$router.push({
        path: "/yard/gateIn"
      });
    },

    viewServiceEstimation() {
      this.isLoading = true;
      let client_detail = {
        view: "view"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewGateIn.php`,
        data: JSON.stringify(client_detail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (
          
            
            status == 200 &&
            data
          ) {
            console.log(data)
            if (data.itemArray.length > 0) {
              this.itemServiceDetails = data.itemArray;
              this.totalRows1 = data.itemArray.length;
            } else {
              this.itemServiceDetails = [];
            }

            if (data.surveyer.length > 0) {
              this.containerDetails = data.surveyer;
              this.totalRows = data.surveyer.length;
          
            } else {
              this.containerDetails = [];
            }

            this.designation =
              this.$sessionsStorage.get("userLevel") == "1"
                ? "manager"
                : data.UserDetail[0].designation;
            this.departmentName = data.UserDetail[0]["departmentName"];
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  margin-top: 1px;
}
/* .marg-top {
  margin-top: -1%;
} */

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}
</style>


// WEBPACK FOOTER //
// viewGateIn.vue?7b92fa66